module.exports = "/images/icon-onboarding-email.svg?c0aa6e168d2bb91c1298d7a96554eca0";